/**
 * @generated SignedSource<<6394ee48cfa7bce1ec247d68dba984f8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutSteps_viewer$data = {
  readonly isPaymentMethodSelectorEnabled: boolean | null;
  readonly stripeIsEnabled: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutDeliveryStep_viewer" | "CheckoutPaymentStepSelector_viewer" | "CheckoutPaymentStepStripe_viewer" | "CheckoutPaymentStep_viewer" | "CheckoutReviewStep_viewer" | "CheckoutShippingStep_viewer">;
  readonly " $fragmentType": "CheckoutSteps_viewer";
};
export type CheckoutSteps_viewer$key = {
  readonly " $data"?: CheckoutSteps_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSteps_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutSteps_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutShippingStep_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutReviewStep_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutDeliveryStep_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutPaymentStep_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutPaymentStepStripe_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutPaymentStepSelector_viewer"
    },
    {
      "alias": "stripeIsEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "stripeCheckout"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"stripeCheckout\")"
    },
    {
      "alias": "isPaymentMethodSelectorEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "checkoutPaymentMethodSelector"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"checkoutPaymentMethodSelector\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "0ada67f274d34a6b4e7e76fb27035c0a";

export default node;
